import React from "react";
import {
  selectElement,
  selectLabel,
  selectWrapper,
  errorTextElement,
} from "./inputSelect.module.css";

/**
 * type is for the input type itself
 * inputType is to choose between "textarea" or 'input'
 * error is the error state of the textField
 * icon should take icons in a html elements
 * errorText holds the error message if you want to show one
 *
 */
const InputSelect = ({
  onClick = () => {},
  type,
  placeholder,
  value,
  className,
  label,
  onChange,
  inputType,
  disabled,
  name,
  required,
  error,
  icon,
  selectText,
  errorText,
  options = [],
  ...restProps
}) => {
  return (
    <div className={`${className} ${selectWrapper}`}>
      <label className={`className ${selectLabel}`}> {label}</label>
      <select
        className={`className ${selectElement}`}
        name={name}
        onChange={onChange}
        disabled={disabled}
        defaultValue={value}
      >
        <option disabled value="">
          {placeholder}
        </option>
        {options.map((x, ind) => (
          <option
            key={ind}
            className={`className ${selectElement}`}
            value={x?.value ?? x}
            selected={x?.value ? x?.value === value : x === value}
          >
            {x?.name ?? x}
          </option>
        ))}
      </select>
      <span>{icon}</span>
      <p className={errorTextElement}>{errorText}</p>
    </div>
  );
};

export { InputSelect };
